<template>
	<div class="items" :class="{orderlist}">
		<item v-for="item in products" v-bind="[item, {orderlist}]" :key="item.id"/>
	</div>
</template>

<script>
import item from "./item/index.vue";

export default {
	components: {item},
	props: {
		orderlist: {type: Boolean, required: false}
	},
	computed: {
		products: (t) => t.$store.getters["cart/products"]
	}
};
</script>

<style lang="scss" scoped>
.items {
	background-color: $white1;
	padding: em(20) em(24);
	overflow: auto;
	height: 100%;

	@include res(500) {
		padding: 0;
	}

	&.orderlist {
		background-color: transparent;
		padding: 0;
	}
}
</style>
